// src/config.ts
export const API_BASE =
  // Let .env override in prod builds, else fall back to localhost
  process.env.REACT_APP_API_BASE_URL || "http://localhost:5000/api";
